import { render } from "./offersView.vue?vue&type=template&id=73c27a94"
import script from "./offersView.vue?vue&type=script&lang=js"
export * from "./offersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__